module.exports = __webpack_public_path__ + "static/media/covi_del_phy_dis.25c33cd7.png";